export const imagePreviewMessages = {
  fileSizeMB: 'MB',
  imageAltPrefix: 'Image',
  removeImageAriaLabel: 'Remove image',
} as const;
